/* ============================================================
   Crazygifts — UI enhancements (vanilla, no dependencies)
   Classic script (defer). NEVER hides content: reveal state is
   only armed AFTER this script runs, so no-JS = fully visible.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -- Scroll reveals via IntersectionObserver -- */
  function initReveals() {
    var els = document.querySelectorAll('[data-cg-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // Arm the hidden start-state only now that JS is running.
    document.documentElement.classList.add('cg-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var d = el.getAttribute('data-cg-delay');
          if (d) el.style.transitionDelay = d + 's';
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* -- Staggered groups: children reveal in sequence -- */
  function initStagger() {
    var groups = document.querySelectorAll('[data-cg-stagger]');
    if (!groups.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      groups.forEach(function (g) {
        Array.prototype.forEach.call(g.children, function (c) { c.classList.add('is-in'); });
      });
      return;
    }
    document.documentElement.classList.add('cg-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var kids = e.target.children;
        Array.prototype.forEach.call(kids, function (c, i) {
          c.style.transitionDelay = (i * 0.07) + 's';
          c.classList.add('is-in');
        });
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    groups.forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c) { c.classList.add('cg-stag'); });
      io.observe(g);
    });
  }

  /* -- Horizontal rails (prev/next) -- */
  function initRails() {
    document.querySelectorAll('[data-cg-rail]').forEach(function (rail) {
      var scope = rail.closest('section') || document;
      var prev = scope.querySelector('[data-cg-rail-prev]');
      var next = scope.querySelector('[data-cg-rail-next]');
      var step = function () { return Math.max(rail.clientWidth * 0.8, 260); };
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* -- Header: add shadow/solid bg after scrolling past hero -- */
  function initHeaderScroll() {
    var onScroll = function () {
      document.documentElement.classList.toggle('cg-scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -- Product page: gallery, quantity, variant, sticky bar -- */
  function initPDP() {
    var pdp = document.querySelector('[data-cg-pdp]');
    if (!pdp) return;

    // gallery thumbs
    var main = document.getElementById('cgPdpMain');
    pdp.querySelectorAll('[data-cg-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.getAttribute('data-cg-thumb');
        pdp.querySelectorAll('.cg-pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    var qi = pdp.querySelector('.cg-qty__i');
    var sel = document.getElementById('cgVariant');
    var amt = pdp.querySelector('.cg-pdp__amt');
    var addBtn = pdp.querySelector('.cg-pdp__add');

    // money formatter (uses the shop's money format, like the cart drawer)
    var mf = (window.CG_CFG && CG_CFG.moneyFormat) || '${{amount}}';
    function money(cents) {
      function n(dec) { return (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
      return mf.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) { return name.indexOf('no_decimals') > -1 ? n(0) : n(2); });
    }
    function qty() { return Math.max(1, parseInt(qi && qi.value, 10) || 1); }
    // current unit price in cents: from selected variant option, else the add button's data-cents
    function unitCents() {
      if (sel && sel.options[sel.selectedIndex]) {
        var c = parseInt(sel.options[sel.selectedIndex].getAttribute('data-cents'), 10);
        if (!isNaN(c)) return c;
      }
      return parseInt(addBtn && addBtn.getAttribute('data-cents'), 10) || 0;
    }
    // keep the add-to-cart button total = unit price × quantity
    // function syncAddBtn() {
    //   if (!addBtn || addBtn.disabled || addBtn.dataset.loading) return;
    //   var cents = unitCents();
    //   var label = addBtn.getAttribute('data-add-label') || 'Add to cart';
    //   if (cents > 0) addBtn.textContent = label + ' · ' + money(cents * qty());
    // }
    function syncAddBtn() {
  if (!addBtn || addBtn.disabled || addBtn.dataset.loading) return;
  var label = addBtn.getAttribute('data-add-label') || 'Add to cart';
  addBtn.textContent = label;
}
    // quantity steppers
    pdp.querySelectorAll('[data-cg-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qi) return;
        qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.getAttribute('data-cg-qty'), 10));
        syncAddBtn();
      });
    });
    if (qi) qi.addEventListener('input', syncAddBtn);

    // variant -> update unit price display + button total
    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var price = opt.getAttribute('data-price');
        if (price && amt) amt.textContent = price;
        var c = parseInt(opt.getAttribute('data-cents'), 10);
        if (!isNaN(c) && addBtn) addBtn.setAttribute('data-cents', c);
        syncAddBtn();
      });
    }
    syncAddBtn();

    // sticky add-to-cart bar
    var sticky = document.getElementById('cgPdpSticky');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }, { rootMargin: '0px' }).observe(addBtn);
    }
  }

  /* -- Mobile menu drawer -- */
  function initMobileMenu() {
    var nav = document.getElementById('cgMnav');
    if (!nav) return;
    var open = function () { nav.hidden = false; document.body.style.overflow = 'hidden'; };
    var close = function () { nav.hidden = true; document.body.style.overflow = ''; };
    document.querySelectorAll('[data-cg-menu-open]').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('[data-cg-menu-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) close(); });
  }

  /* -- Wishlist manager (localStorage) -- */
  function initWishlist() {
    function getWishlist() {
      try { return JSON.parse(localStorage.getItem('cg_wishlist')) || []; }
      catch (e) { return []; }
    }
    function setWishlist(list) {
      try { localStorage.setItem('cg_wishlist', JSON.stringify(list)); }
      catch (e) {}
      updateWishlistUI();
    }
    function updateWishlistUI() {
      var list = getWishlist();
      var count = list.length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = count;
        el.setAttribute('data-wishlist-count', count);
      });
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.getAttribute('data-wishlist-toggle');
        var exists = list.some(function (item) { return item.handle === handle; });
        btn.classList.toggle('is-active', exists);
      });

      var html = list.map(function (item) {
        return '<article class="cg-card">' +
          '<div class="cg-card__media">' +
            '<img class="cg-card__img" src="' + (item.image || '') + '" alt="' + (item.title || '') + '" loading="lazy">' +
            '<button type="button" class="cg-card__wish is-active" data-wishlist-toggle="' + item.handle + '" aria-label="Remove">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="cg-card__body">' +
            '<h3 class="cg-card__title"><a href="' + (item.url || '#') + '">' + (item.title || 'Saved Gift') + '</a></h3>' +
            '<div class="cg-card__price"><span class="cg-card__amt">' + (item.price || '') + '</span></div>' +
            '<a href="' + (item.url || '#') + '" class="cg-btn cg-btn--sm cg-btn--dark" style="margin-top:0.6rem;width:100%">View product</a>' +
          '</div>' +
        '</article>';
      }).join('');
      document.querySelectorAll('.js-wish-grid').forEach(function (grid) { grid.innerHTML = list.length ? html : ''; });
      document.querySelectorAll('.js-wish-empty').forEach(function (empty) { empty.hidden = list.length > 0; });
    }

    // Wishlist drawer open/close (header heart → drawer, no page needed)
    var wd = document.getElementById('cgWishDrawer');
    function openWish() { if (!wd) return; wd.hidden = false; wd.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; requestAnimationFrame(function () { wd.classList.add('is-open'); }); }
    function closeWish() { if (!wd) return; wd.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { wd.hidden = true; wd.setAttribute('aria-hidden', 'true'); }, 320); }
    document.querySelectorAll('.cg-hdr__ic--wish, a[href$="/pages/wishlist"]').forEach(function (a) {
      // On the wishlist page itself, let the link work normally; elsewhere open the drawer
      if (document.querySelector('.cg-wish')) return;
      a.addEventListener('click', function (e) { e.preventDefault(); openWish(); });
    });
    document.querySelectorAll('[data-cg-wish-close]').forEach(function (b) { b.addEventListener('click', closeWish); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wd && !wd.hidden) closeWish(); });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-wishlist-toggle');
      var card = btn.closest('[data-wishlist-card]');
      var list = getWishlist();
      var index = list.findIndex(function (item) { return item.handle === handle; });

      if (index > -1) {
        list.splice(index, 1);
      } else {
        var itemData = {
          handle: handle,
          title: card ? card.getAttribute('data-wish-title') : 'Saved Gift',
          price: card ? card.getAttribute('data-wish-price') : '',
          image: card ? card.getAttribute('data-wish-image') : '',
          url: card ? card.getAttribute('data-wish-url') : '/products/' + handle
        };
        list.push(itemData);
      }
      setWishlist(list);
    });

    updateWishlistUI();
  }

  /* -- Toasts -- */
  function toast(msg, kind) {
    var wrap = document.getElementById('cgToasts');
    if (!wrap) { return; }
    var t = document.createElement('div');
    t.className = 'cg-toast' + (kind ? ' cg-toast--' + kind : '');
    t.textContent = msg;
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 350); }, 3200);
  }

  /* -- AJAX cart + slide-out drawer + free-shipping bar -- */
  function initCart() {
    var drawer = document.getElementById('cgCartDrawer');
    var cfg = window.CG_CFG || { moneyFormat: '${{amount}}', freeShip: 0, routes: { add: '/cart/add', change: '/cart/change', cart: '/cart' } };

    function money(cents) {
      function n(dec) { return (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
      return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
        if (name.indexOf('no_decimals') > -1) return n(0);
        return n(2);
      });
    }

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false; drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open'); document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; drawer.setAttribute('aria-hidden', 'true'); }, 320);
    }

    function render(cart) {
      // counts
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      if (!drawer) return;
      var items = drawer.querySelector('[data-cart-items]');
      var empty = drawer.querySelector('[data-cart-empty]');
      var foot = drawer.querySelector('[data-cart-foot]');
      var ship = drawer.querySelector('[data-ship-bar]');

      if (!cart.items.length) {
        items.innerHTML = ''; empty.hidden = false; foot.hidden = true; if (ship) ship.hidden = true;
        return;
      }
      empty.hidden = true; foot.hidden = false; if (ship) ship.hidden = false;

      items.innerHTML = cart.items.map(function (it) {
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="cg-ci__variant">' + it.variant_title + '</span>' : '';
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" width="64" height="64">' : '';
        return '<div class="cg-ci" data-key="' + it.key + '">' +
          '<a class="cg-ci__img" href="' + it.url + '">' + img + '</a>' +
          '<div class="cg-ci__info">' +
            '<a class="cg-ci__title" href="' + it.url + '">' + it.product_title + '</a>' + variant +
            '<div class="cg-ci__price">' + money(it.final_price) + '</div>' +
            '<div class="cg-ci__ctrls">' +
              '<div class="cg-ci__qty">' +
                '<button type="button" data-ci-dec aria-label="Decrease">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-ci-inc aria-label="Increase">+</button>' +
              '</div>' +
              '<button type="button" class="cg-ci__remove" data-ci-remove>Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="cg-ci__line">' + money(it.final_line_price) + '</div>' +
        '</div>';
      }).join('');

      drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);

      // free shipping bar
      if (ship && cfg.freeShip > 0) {
        var msg = ship.querySelector('[data-ship-msg]');
        var fill = ship.querySelector('[data-ship-fill]');
        var remaining = cfg.freeShip - cart.total_price;
        if (remaining > 0) {
          msg.innerHTML = "You're <strong>" + money(remaining) + "</strong> away from FREE shipping";
          fill.style.width = Math.min(100, (cart.total_price / cfg.freeShip) * 100) + '%';
        } else {
          msg.innerHTML = "🎉 You've unlocked <strong>FREE shipping!</strong>";
          fill.style.width = '100%';
        }
      } else if (ship) { ship.hidden = true; }
    }

    function fetchCart() {
      return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }
    function refresh() { return fetchCart().then(render); }

    function addToCart(id, qty, btn) {
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.dataset.loading = '1'; btn.textContent = 'Adding…'; }
      return fetch(cfg.routes.add + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d.description || 'Could not add to cart', 'err'); return; }
          return refresh().then(function () { openDrawer(); });
        })
        .catch(function () { toast('Something went wrong. Please try again.', 'err'); })
        .finally(function () { if (btn) { btn.disabled = false; delete btn.dataset.loading; btn.textContent = original; } });
    }

    function changeQty(key, qty) {
      return fetch(cfg.routes.change + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render);
    }

    // Open drawer from header cart link
    document.querySelectorAll('a.cg-hdr__cart, [data-cg-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); refresh().then(openDrawer); });
    });
    // Close
    document.querySelectorAll('[data-cg-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });

    // Intercept add-to-cart forms (product cards + PDP), but let "Buy it now" (checkout) pass through
    document.addEventListener('submit', function (e) {
      var form = e.target;
      // NB: match the PDP form by CLASS, not id. The form contains <input name="id">
      // (the variant id) which DOM-clobbers `form.id` — it returns that input node,
      // never the string 'cgPdpForm', so an id check here silently fails → native submit.
      if (!(form.matches('.cg-card__quick-form') || form.matches('.cg-pdp__form'))) return;
      if (e.submitter && e.submitter.name === 'checkout') return; // Buy it now → native
      e.preventDefault();
      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      if (!idField) return;
      addToCart(idField.value, qtyField ? parseInt(qtyField.value, 10) : 1, e.submitter || form.querySelector('[type="submit"]'));
    });

    // Drawer qty controls (delegated)
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var row = e.target.closest('[data-key]'); if (!row) return;
        var key = row.getAttribute('data-key');
        var qtySpan = row.querySelector('.cg-ci__qty span');
        var q = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
        if (e.target.closest('[data-ci-inc]')) changeQty(key, q + 1);
        else if (e.target.closest('[data-ci-dec]')) changeQty(key, Math.max(0, q - 1));
        else if (e.target.closest('[data-ci-remove]')) changeQty(key, 0);
      });
    }

    // initial paint of free-ship bar/count if cart has items
    if (drawer) refresh();
  }

  /* -- Predictive search overlay -- */
  function initSearch() {
    var panel = document.getElementById('cgSearch');
    if (!panel) return;
    var input = panel.querySelector('[data-search-input]');
    var results = panel.querySelector('[data-search-results]');
    var hint = results ? results.innerHTML : '';

    function open() { panel.hidden = false; panel.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; requestAnimationFrame(function () { panel.classList.add('is-open'); if (input) input.focus(); }); }
    function close() { panel.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { panel.hidden = true; panel.setAttribute('aria-hidden', 'true'); }, 300); }

    document.querySelectorAll('[data-cg-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    // Footer "Search gifts" links open the predictive-search overlay instead of the /search page
    document.querySelectorAll('.cg-ft a[href$="/search"], .cg-ft a[href*="/search?"]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    panel.querySelectorAll('[data-cg-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

    var timer;
    if (input) input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = hint; return; }
      results.innerHTML = '<p class="cg-search__hint">Searching…</p>';
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!prods.length) { results.innerHTML = '<p class="cg-search__hint">No matches for "' + q + '". Press Enter to search everything.</p>'; return; }
            var mf = (window.CG_CFG && CG_CFG.moneyFormat) || '${{amount}}';
            var sm = function (v) { var n = parseFloat(v) || 0; return mf.replace(/\{\{\s*\w+\s*\}\}/g, n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); };
            results.innerHTML = '<div class="cg-search__list">' + prods.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              var price = p.price ? '<span class="cg-search__price">' + sm(p.price) + '</span>' : '';
              return '<a class="cg-search__res" href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" width="48" height="48">' : '<span class="cg-search__res-ph"></span>') +
                '<span class="cg-search__res-t">' + p.title + '</span>' + price + '</a>';
            }).join('') + '</div><a class="cg-search__all" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
          })
          .catch(function () { results.innerHTML = '<p class="cg-search__hint">Press Enter to search.</p>'; });
      }, 250);
    });
  }

  function boot() {
    try { initCart(); } catch (e) {}
    try { initSearch(); } catch (e) {}
    try { initReveals(); } catch (e) {}
    try { initStagger(); } catch (e) {}
    try { initRails(); } catch (e) {}
    try { initHeaderScroll(); } catch (e) {}
    try { initMobileMenu(); } catch (e) {}
    try { initPDP(); } catch (e) {}
    try { initWishlist(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

